import React, {useState} from "react";
import styles from "./Footer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { openCookieSettings } from "../../utils/cookieEvents";
import { openPrivacyPolicy } from "../../utils/cookieEvents";
import { openCookiesPolicy } from "../../utils/cookieEvents";
import CookieBanner from "../../HomePage/CookieBanner";
import CookieSettings from "../../HomePage/CookiesSettings";
import CookiesPolicy from "../../HomePage/CookiesPolicy";
import PrivacyPolicy from "../../HomePage/PrivacyPolicy";

export default function Footer() {
  const [cookieSettings, setCookieSettings] = useState({
    analytics: false,
    marketing: false
  });

  return (
    <footer className={styles.footerContent}>
      <div className={styles.firstSectionOfFooter}>
        <div className={styles.footerItem}>
          <div className={styles.footerTitle}>
            <h5>Firma</h5>
            <p>Cały rok z Nami przejeździsz bezpieczenie.</p>
          </div>
          <div className={styles.iconGroup}>
            <a
              href="https://www.facebook.com/profile.php?id=61582676480636"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.icon}
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              href="/#"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.icon}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
        <div className={styles.footerItem}>
          <h4>Firma</h4>
          <p className={styles.footerParagraph}>
            <a href="#hero" className={styles.footerLink}>
              Strona główna
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#aboutUs" className={styles.footerLink}>
              O nas
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Usługi
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#work" className={styles.footerLink}>
              Jak pracujemy
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#tariff" className={styles.footerLink}>
              Cennik
            </a>
          </p>
          {/* <p className={styles.footerParagraph}>
          <a href="#gallery" className={styles.footerLink}>
            Galeria
          </a>
        </p> */}
          {/* <p className={styles.footerParagraph}>
          <a href="#faq" className={styles.footerLink}>
            FAQ
          </a>
        </p> */}
          <p className={styles.footerParagraph}>
            <a href="#contact" className={styles.footerLink}>
              Kontakt
            </a>
          </p>
        </div>
        <div className={styles.footerItem}>
          <h4>Usługi</h4>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Wymiana opon
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Wyważanie kół
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Naprawa opon
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Sezonowe przechowywanie opon
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Pomiar i uzupełnienie ciśnieia w oponacha
            </a>
          </p>
          <p className={styles.footerParagraph}>
            <a href="#services" className={styles.footerLink}>
              Czyszczenie i konserwacja felg
            </a>
          </p>
        </div>
        <div className={styles.footerItem}>
          <h4>Kontakt</h4>
          <p className={styles.footerContactItem}>Tel: xxx xxx xxx</p>
          <p className={styles.footerContactItem}>
            Email: <br />
            e-mail firmy
          </p>
          <p className={styles.footerContactItem}>
            adres firmy
          </p>
          <p className={styles.footerContactItem}>NIP: nip firmy</p>
        </div>
      </div>
      <div className={styles.secondSectionOfFooter}>
        <p className={styles.sign}>
          &copy; 2026 ArtKoz. Wszelkie prawa zastrzeżone.
        </p>
        <div className={styles.footerButton}>
          <button
            type="button"
            id="setting-cookies"
            className={styles.infoBtn}
            onClick={openCookieSettings}
          >
            Zmień ustawienia cookies
          </button>
          <button
            type="button"
            id="cookies-policy"
            className={styles.infoBtn}
            onClick={openCookiesPolicy}
          >
            Polityka cookies
          </button>
          <button
            type="button"
            id="policy-privacy"
            className={styles.infoBtn}
            onClick={openPrivacyPolicy}
          >
            Polityka prywatności
          </button>
        </div>
      </div>
      <CookieBanner />
      <CookieSettings
        settings={cookieSettings}
        setSettings={setCookieSettings}
      />
      <CookiesPolicy />
      <PrivacyPolicy />
    </footer>
  );
}
